var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoninBookLoadingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_64",
    "data-name": "Group 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 125,
    height: 135.369,
    viewBox: "0 0 125 135.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 125,
    height: 135.369,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 27.25,
    height: 45.284,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 0.09,
    height: 0.052,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 6.584,
    height: 6.399,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 5.972,
    height: 6.399,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 6.921,
    height: 7.521,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 5.792,
    height: 5.925,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 6.013,
    height: 5.831,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 5.079,
    height: 4.918,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 5.822,
    height: 6.441,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 5.493,
    height: 5.721,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 6.874,
    height: 7.039,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 6.081,
    height: 6.562,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 27.229,
    height: 100.378,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 0.014,
    height: 0.037,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 89.194,
    height: 135.142,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 0.013,
    height: 0.125,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 0.006,
    height: 0.013,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 0.023,
    height: 0.064,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 41.529,
    height: 25.554,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 31.427,
    height: 63.323,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M35.227,124.732a2.693,2.693,0,0,1-.457-1.315q-.063-.236-.133-.471c-.31-.955-.66-1.9-.977-2.85q-.5-1.487-.963-2.986c-.62-2-1.151-4.027-1.592-6.015-.54-2.425-1.007-4.865-1.443-7.313s-.82-4.877-1.273-7.309c-.388-2.094-.819-4.182-1.275-6.262-.547-2.37-1.183-4.716-1.876-7.046-.682-2.293-1.4-4.575-2.089-6.865-1.42-4.719-2.891-9.424-4.19-14.178-.319-1.17-.663-2.332-.978-3.5q-.479-1.78-.948-3.564c-.309-1.181-.6-2.367-.884-3.553-.3-1.222-.6-2.445-.87-3.673-.029-.126-.057-.249-.084-.375s-.061-.275-.092-.413c-.085-.387-.17-.773-.217-.982-.645-2.872-1.433-5.705-2.286-8.465-.03-.1-.061-.2-.081-.261-.281-.9-.567-1.806-.841-2.689A58.735,58.735,0,0,1,9.911,27.87a12.115,12.115,0,0,1-.228-1.931,13.5,13.5,0,0,1,.06-1.553,4.281,4.281,0,0,1,.442-1.663,4.709,4.709,0,0,1,.986-1.187,8.065,8.065,0,0,1,2.246-1.492,10.921,10.921,0,0,1,2.529-.675c.935-.158,1.887-.193,2.832-.264a27.185,27.185,0,0,0,2.805-.359c1.2-.225,2.383-.5,3.568-.794,1.152-.283,2.3-.559,3.456-.84,1.178-.287,2.357-.568,3.529-.883,1.154-.31,2.3-.645,3.445-1,2.319-.715,4.522-1.736,6.783-2.607,1.167-.45,2.354-.834,3.556-1.183,1.172-.341,2.348-.675,3.527-.988s2.378-.637,3.582-.889A18.171,18.171,0,0,1,55.018,9.3c.648-.062,1.293-.142,1.934-.251a20.9,20.9,0,0,0,3.313-.97c1.075-.408,2.129-.869,3.212-1.255s2.188-.709,3.3-.984a14.028,14.028,0,0,1,1.93-.329c.606-.063,1.212-.117,1.816-.205l.263-.043a44.975,44.975,0,0,0,6.506-2c.558-.2,1.119-.385,1.675-.585.583-.209,1.169-.417,1.771-.568.557-.139,1.121-.251,1.688-.349.545-.093,1.1-.146,1.645-.24.755-.144,1.5-.347,2.238-.551.361-.1.724-.2,1.089-.29A24.8,24.8,0,0,1,90.683.054,5.449,5.449,0,0,1,92.327.07,4.226,4.226,0,0,1,93.8.652a4.817,4.817,0,0,1,1.363,1.5,17.105,17.105,0,0,1,1.092,1.97,47.325,47.325,0,0,1,3.089,9.994l.082.371c.795,3.535,1.462,7.1,2.235,10.638.485,2.149,1.027,4.285,1.589,6.416.553,2.1,1.124,4.187,1.759,6.26.685,2.18,1.389,4.353,2.037,6.442l0,.013c.135.435.271.869.335,1.085.091.29.18.579.2.65.31,1,.615,2,.855,2.775l.029.092q.117.381.235.758c.021.064.041.127.06.192.062.179.112.363.123.4l.051.163.031.1c0,.015.009.029.014.044l.021.068c.042.134.084.269.095.308.758,2.44,1.471,4.893,2.2,7.34q1.073,3.583,2.084,7.185c.689,2.443,1.347,4.895,1.993,7.349.642,2.438,1.28,4.881,1.874,7.332.629,2.6,1.218,5.2,1.787,7.776l.036.157v.006c.032.142.064.283.084.375.637,2.85,1.336,5.684,2.007,8.524.066.28.185,1.062-.3,1.08a.676.676,0,0,1-.485-.3,1.878,1.878,0,0,1-.376-.756c-.565-2.395-1.094-4.8-1.663-7.192s-1.2-4.771-1.775-7.16c-.591-2.443-1.187-4.885-1.822-7.318-.645-2.469-1.369-4.92-2.075-7.372-.625-2.175-1.219-4.358-1.841-6.533-.645-2.255-1.323-4.5-2.013-6.745l-.021-.07,0-.014-.149-.477c-.095-.306-.191-.612-.22-.705-.293-.93-.59-1.858-.859-2.726l-.04-.124-.01-.031-.076-.24c-.026-.073-.049-.147-.07-.221-.093-.3-.187-.593-.279-.89-.064-.2-.128-.4-.174-.555l-.046-.148-.01-.03c-.076-.241-.152-.482-.221-.7-.079-.251-.157-.5-.167-.533-.094-.3-.189-.6-.215-.689-.079-.255-.158-.511-.2-.649-.744-2.388-1.458-4.784-2.167-7.182-.7-2.377-1.4-4.756-2.049-7.148-.664-2.444-1.3-4.893-1.831-7.371-.513-2.41-.961-4.834-1.451-7.25q-.205-1.013-.428-2.025c-.4-1.77-.826-3.536-1.358-5.275q-.063-.2-.127-.408c-.277-.856-.583-1.7-.9-2.542Q95.4,5.8,95.007,4.99c-.123-.234-.249-.464-.384-.692q-.119-.184-.244-.364-.118-.15-.244-.294c-.043-.043-.087-.084-.131-.126-.072-.055-.145-.107-.22-.158s-.147-.075-.223-.108a4.7,4.7,0,0,0-.831-.194,15.572,15.572,0,0,0-2.724.018c-.5.038-1.014.071-1.516.139s-1.017.166-1.461.247c-.586.108-1.17.226-1.75.37-.562.141-1.109.326-1.662.5a32.022,32.022,0,0,1-3.471.813c-2.292.439-4.55,1.062-6.8,1.687a25.035,25.035,0,0,0-3,.987c-.505.212-1,.444-1.507.657-.491.206-.995.377-1.5.542-.962.313-1.938.594-2.918.844-1,.254-2.007.45-3.022.635-1.129.213-2.253.458-3.357.779-1.19.348-2.341.792-3.519,1.168-.552.175-1.124.29-1.689.416s-1.132.257-1.7.386c-1.183.27-2.363.558-3.536.879-1.218.332-2.428.692-3.626,1.091-1.141.381-2.275.781-3.418,1.163-2.288.762-4.584,1.483-6.916,2.1S28.952,19.63,26.586,20.1c-1.2.239-2.417.426-3.631.6-1.144.167-2.293.283-3.442.419-.744.088-1.487.189-2.231.276-.723.087-1.447.159-2.165.284A7.718,7.718,0,0,0,13,22.4a6.071,6.071,0,0,0-1.153.846,4.642,4.642,0,0,0-.6.756,3.687,3.687,0,0,0-.2.441c-.027.095-.051.189-.071.285-.024.15-.041.3-.053.45-.011.244-.012.487,0,.731.035.6.1,1.2.176,1.8s.2,1.189.319,1.779c.52,2.278,1.233,4.514,1.9,6.751.7,2.34,1.36,4.688,2.009,7.042.658,2.379,1.348,4.75,1.963,7.139.326,1.265.623,2.535.9,3.809.243,1.12.458,2.248.693,3.371.078.372.158.742.22,1.031.007.029.014.058.02.088v0c.536,2.344,1.191,4.662,1.849,6.975.668,2.352,1.4,4.686,2.113,7.024,1.424,4.67,2.827,9.353,3.993,14.1.6,2.434,1.12,4.883,1.647,7.333s1.068,4.879,1.548,7.332c.5,2.548,1,5.093,1.524,7.459l.015.067c.56,2.448,1.167,4.885,1.9,7.288q.55,1.712,1.136,3.41c.385,1.124.758,2.258,1.192,3.365l.036.08a2.752,2.752,0,0,1,.38,1.155c.026.307.011.838-.349.965a.268.268,0,0,1-.033.01c-.349.094-.68-.291-.848-.54",
    transform: "translate(-1.977 0)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M120.361,137.543a45.489,45.489,0,0,1-4.861.814c-1.211.288-2.352.818-3.594,1.009-1.417.226-2.817.534-4.216.852a14.08,14.08,0,0,0-4.234,1.422,40.474,40.474,0,0,1-4.2,1.483,79.541,79.541,0,0,1-9.654,2.165c-1.072.21-2.048.709-3.089,1.023-2,.569-4.07.89-6.091,1.4-3.011.813-6.013,1.654-9,2.554-3.008.818-6.113,1.249-9.063,2.3-3.028,1.015-6.146,1.731-9.2,2.669-2.017.579-4.1,1.358-6.225,1.027-3.225-.556-4.509-4.153-5.208-6.95a41.72,41.72,0,0,0-1.255-4.329,4.462,4.462,0,0,1-.4-1.973c.484-.873,1.251,1.363,1.367,1.731.6,1.834,1.191,3.672,1.91,5.463a5,5,0,0,0,2.113,2.8c1.37.871,3.047.742,4.6.674,4.169-.1,7.868-2.14,11.757-3.381,2.983-.9,6.1-1.3,9.065-2.272,4.986-1.478,10-2.887,15.04-4.167a20.35,20.35,0,0,0,4.624-1.412c2.381-.867,4.788-1.666,7.225-2.356,2.443-.836,5.047-.954,7.508-1.68,1.818-.66,3.526-1.594,5.357-2.222,1.753-.653,3.626-.536,5.451-.738,1.085-.264,2.184-.47,3.288-.64a22.92,22.92,0,0,0,6.395-2.264,14.531,14.531,0,0,0,2.461-2.126,2.356,2.356,0,0,0,.567-1c-.106-3.326-1.2-6.554-2.163-9.7-.216.111-.383-.253-.419-.409-.229-.951-.473-1.9-.757-2.834-.133-.412-.265-.826-.4-1.237a1.774,1.774,0,0,1-.1-1.491c.455-.432.953.347,1.1.735a108.933,108.933,0,0,1,3.721,14.736c.288,1.42.937,3.08-.211,4.295a10.389,10.389,0,0,1-4.631,2.707,36.513,36.513,0,0,1-4.577,1.329",
    transform: "translate(-8.178 -23.201)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M120.12,114.714a.477.477,0,0,0-.337-.147.57.57,0,0,1,.337.147M94.712,7.417c3.573,9.676,5.126,20.067,7.315,30.024,2.524,10.368,5.8,20.537,8.593,30.83,2.836,10.223,5.415,20.637,7.663,30.948.256,2.145,4.767,17.7,1.942,17.075-.692-.237-.757-1.117-.684-1.732-.827-7.731-2.7-15.554-4.258-23.125-3.416-15.817-8.483-31.2-12.667-46.823-1.474-5.126-2.939-10.259-3.918-15.508-.992-5.039-1.561-9.937-2.919-14.751C95.017,11.5,94.3,8.539,92.4,6.2a3.939,3.939,0,0,1-.5-1.265c.5-.173,1-.352,1.492-.529a15.107,15.107,0,0,1,1.322,3.01",
    transform: "translate(-18.767 -0.9)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M116.159,43.231a17.89,17.89,0,0,1,.489,1.812c.154.668.3,1.337.418,2.013.2,1.093.453,2.179.727,3.256.13.513.279,1.024.448,1.527.187.558.412,1.1.621,1.65a12.276,12.276,0,0,1,.444,1.56,4.11,4.11,0,0,1,.1,1.348,2.873,2.873,0,0,1-1.016,1.707,5.983,5.983,0,0,1-.793.615c-.309.211-.625.415-.943.61q-.239.144-.482.285c.1,0,.2.007.3.015a3.512,3.512,0,0,1,2,.9,6.049,6.049,0,0,1,1.138,1.4c.345.548.641,1.131.935,1.708.251.488.5.978.731,1.475a23.512,23.512,0,0,1,1.352,3.544c.314,1.1.554,2.23.771,3.357s.388,2.289.633,3.423a17.466,17.466,0,0,0,.856,2.711,13.085,13.085,0,0,1,.508,1.383,3.189,3.189,0,0,1,.1.721,1.693,1.693,0,0,1-.244.853,4.532,4.532,0,0,1-.409.646,4.407,4.407,0,0,1-.782.753,8.811,8.811,0,0,1-1.173.811c-.275.157-.562.293-.84.446l-.092.077a5.114,5.114,0,0,1-.975.622,9.572,9.572,0,0,1-1.59.594c-.329.095-.661.175-.988.275-.229.068-.457.14-.687.2l-.176.045a3.4,3.4,0,0,1-1.126.113,1.15,1.15,0,0,1-.882-.4c-.376-.589.534-1.15.954-1.343.237-.109.477-.208.719-.3.448-.185.875-.415,1.319-.606a11.1,11.1,0,0,1,1.308-.471c.106-.032.212-.057.318-.083l.062-.015c.056-.033.113-.064.169-.1.224-.148.446-.3.661-.464.09-.076.181-.152.267-.233.018-.019.034-.038.051-.058l.014-.025c.006-.016.012-.033.017-.048.014-.148,0-.3.007-.446a4.572,4.572,0,0,0-.02-.521,12.336,12.336,0,0,0-.6-2.162,28.265,28.265,0,0,1-.713-2.955c-.238-1.163-.431-2.336-.594-3.513a31.348,31.348,0,0,0-.541-3.387c-.152-.593-.3-1.187-.473-1.772a16.514,16.514,0,0,0-.627-1.677,10.836,10.836,0,0,0-1.59-2.555,5.825,5.825,0,0,0-.859-.791c-.1-.063-.2-.121-.3-.176-.068-.026-.136-.049-.205-.072l-.1-.021a.047.047,0,0,0-.015,0c-.06,0-.121,0-.182,0-.422.031-.843.082-1.261.138-1.149.17-2.305.355-3.439.6-.242.056-.482.116-.727.162a1.612,1.612,0,0,1-1.294-.185c-.357-.323.006-.771.306-.972a5.246,5.246,0,0,1,1.091-.477c.267-.1.536-.2.8-.309l.253-.1c.493-.2.984-.4,1.484-.585.624-.229,1.253-.446,1.873-.68.2-.088.4-.179.6-.277s.373-.2.556-.307l.1-.072c.027-.023.053-.045.079-.07.088-.1.173-.2.255-.3l.012-.018c.028-.08.05-.159.07-.24a1.086,1.086,0,0,0,.009-.144c-.076-.513-.22-1.017-.329-1.523-.078-.368-.162-.737-.23-1.108-.086-.454-.123-.916-.166-1.376a27.1,27.1,0,0,0-.491-2.78c-.243-1.066-.507-2.122-.833-3.166-.356-1.139-.7-2.289-.99-3.447-.143-.563-.274-1.126-.446-1.681a14.245,14.245,0,0,0-.543-1.459,10.361,10.361,0,0,0-1.424-2.341,6.248,6.248,0,0,0-.786-.715,5.665,5.665,0,0,0-.594-.327c-.141-.053-.282-.1-.426-.146-.061-.015-.125-.03-.189-.042h-.033c-.1.009-.208.019-.312.033-.318.049-.634.109-.948.176-.665.16-1.319.357-1.987.508-.432.1-.865.193-1.3.27a3.38,3.38,0,0,1-1.527.05.946.946,0,0,1-.2-.087.455.455,0,0,1-.179-.668,1.924,1.924,0,0,1,.995-.707c.4-.164.809-.3,1.226-.425a17,17,0,0,1,1.83-.426c.493-.159.985-.321,1.47-.509.209-.088.415-.183.618-.282.074-.041.148-.082.22-.126s.148-.1.22-.151c.045-.04.09-.079.134-.119s.066-.076.1-.115c.048-.07.094-.14.136-.214.008-.023.014-.047.021-.07a2.662,2.662,0,0,0,.029-.6,19.267,19.267,0,0,0-.416-2.049c-.123-.511-.2-1.027-.319-1.538-.105-.473-.22-.943-.339-1.412-.132-.526-.263-1.054-.417-1.573s-.335-1.023-.475-1.541a9.9,9.9,0,0,1-.238-1.481c-.068-.6-.119-1.213-.179-1.818-.113-1.074-.24-2.146-.446-3.206-.111-.562-.245-1.12-.372-1.678a10.714,10.714,0,0,0-.547-1.744,7.094,7.094,0,0,0-.853-1.384,5.855,5.855,0,0,0-.77-.71,6.549,6.549,0,0,0-.756-.429c-.095-.037-.19-.072-.286-.1q-.195-.048-.392-.081c-.169-.021-.337-.04-.507-.05-.139,0-.28,0-.42.007-.24.018-.48.046-.718.077-.259.041-.516.089-.772.143-.493.118-.984.239-1.477.351a7.762,7.762,0,0,1-.972.177,2.662,2.662,0,0,1-.637,0q-.124-.443-.254-.883a2.877,2.877,0,0,1,.353-.237,4.449,4.449,0,0,1,1.024-.411,14.721,14.721,0,0,1,1.709-.39,16.6,16.6,0,0,1,3.66-.267,5.412,5.412,0,0,1,3.487,1.427A8.233,8.233,0,0,1,108,16.712a23.3,23.3,0,0,1,.757,4.427c.109.817.268,1.625.447,2.43.083.373.163.748.236,1.124.084.433.112.875.145,1.191a18.357,18.357,0,0,0,.75,3.575c.182.581.43,1.138.614,1.719.146.458.273.925.384,1.393.08.338.127.682.2,1.02.027.126.055.252.084.377a1.173,1.173,0,0,1-.1.923,3.223,3.223,0,0,1-1.1,1.019q.186.048.371.113a5.947,5.947,0,0,1,1.613,1,10.185,10.185,0,0,1,1.273,1.163,7.216,7.216,0,0,1,1.077,1.575,18.4,18.4,0,0,1,.752,1.713c.228.583.455,1.167.659,1.76",
    transform: "translate(-19.571 -2.419)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M130.288,101.556c3.788,4.083,4.023,10.153,5.385,15.306.607,2.724,1.611,5.37-.778,7.577-1.346,1.543-3.394,2.215-5.249,2.952-1.6.544-3.144,1.569-4.881,1.533a2.5,2.5,0,0,1-.443-.088c-.014-.084-.027-.165-.041-.247q-.035-.217-.071-.432t-.072-.432c-.01-.062-.021-.124-.032-.188a2.533,2.533,0,0,1,1.348-.711c2.391-.625,5.466-1.218,6.853-3.447a10.8,10.8,0,0,0-.261-4.842c-.6-2.792-.739-5.66-1.436-8.433-.568-2.309-1.028-4.978-2.877-6.634-1.9-.334-4.085.364-6.027.681a17.1,17.1,0,0,1-2.4.527c-.128-.524-.257-1.049-.387-1.572a17.308,17.308,0,0,1,3.131-.9c2.621-.336,5.74-2,8.237-.648",
    transform: "translate(-24.285 -20.632)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M125.477,134.575a.516.516,0,0,1,.368.325.584.584,0,0,1-.225.539c-.047-.289-.093-.576-.143-.864",
    transform: "translate(-25.624 -27.482)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M76.427,110.6a14.513,14.513,0,0,1-6.241-2.932c-6.292-3.881-10.041-10.955-13.12-17.456-1.569-3.685-2.87-7.616-2.348-11.654a17.5,17.5,0,0,1,1.611-6c2.018-3.289,6.569-5.29,9.986-6.855,14.974-5.808,21.213,8.548,21.521,21.115.185,5.17.328,10.476-1.346,15.442-.99,2.664-2.343,5.4-4.764,7.028a7.577,7.577,0,0,1-5.3,1.308m2.336-2.658c2.623-.857,4.047-3.412,5.316-5.674,2.3-4.353,2.578-9.4,2.3-14.231a54.4,54.4,0,0,0-.715-7.642A25.149,25.149,0,0,0,82.109,71.1,7.259,7.259,0,0,0,76.4,67.574c-6.636-1-14.244.744-18.333,6.421-2.749,4.05-2.323,9.444-.589,13.816,2.745,6.845,6.529,13.958,13.026,17.874,2.547,1.306,5.329,2.745,8.259,2.252",
    transform: "translate(-11.15 -13.146)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M73.6,114.725c-.745-.006-1.489.01-2.233.014-.664-.01-1.327-.041-1.989-.08q-.9-.051-1.8-.111a24.761,24.761,0,0,1-2.991-1.324c-.984-.523-1.953-1.088-2.89-1.691-.953-.613-1.887-1.261-2.779-1.958-.442-.344-.87-.7-1.293-1.064s-.827-.774-1.224-1.176c-.755-.763-1.454-1.588-2.145-2.408a31,31,0,0,1-1.937-2.59,54.972,54.972,0,0,1-3.453-5.851,56.238,56.238,0,0,1-2.574-5.916,48.014,48.014,0,0,1-1.869-6.451,20.173,20.173,0,0,1-.288-6.57c.06-.555.14-1.108.23-1.662s.228-1.09.369-1.631A28.272,28.272,0,0,1,47.189,68.2q.742-1.4,1.615-2.718c.579-.876,1.219-1.721,1.878-2.54a26.594,26.594,0,0,1,2.287-2.531A20.638,20.638,0,0,1,55.4,58.379c.883-.621,1.816-1.171,2.75-1.707a29.167,29.167,0,0,1,4.492-2.18c.757-.276,1.534-.49,2.313-.69q1.287-.332,2.586-.6c.2-.041.426.168.548.3a2.177,2.177,0,0,1,.45.807c.111.35.24,1.091-.265,1.194-.4.082-.793.171-1.089.24q-1.325.32-2.632.711c-.9.27-1.775.579-2.647.919a32.44,32.44,0,0,0-4.976,2.438c-.366.232-.73.469-1.077.727s-.691.545-1.023.835C54.1,62,53.405,62.663,52.8,63.3l-.373.423c-.419.49-.825.988-1.222,1.5s-.826,1.031-1.191,1.578c-.732,1.094-1.4,2.217-2.024,3.377-.423.832-.833,1.669-1.179,2.536-.359.9-.667,1.811-.952,2.735-.128.477-.247.953-.357,1.435-.1.458-.158.933-.228,1.4-.1.778-.16,1.55-.2,2.333l0,.177c0,.185-.006.368-.009.539,0,.019,0,.037,0,.057v.007c0,.486.04.972.077,1.457.061.5.132.989.214,1.482.212,1.116.451,2.222.735,3.321.27.93.564,1.846.871,2.752.007.021.015.041.022.06l0,.014c.018.048.035.1.053.145.042.119.086.24.127.351l.017.047c.007.02.014.038.017.045l.047.127c.012.034.025.068.037.1s.017.048.025.072c.339.909.728,1.8,1.123,2.683.592,1.253,1.21,2.487,1.884,3.7q.486.818.979,1.629c.329.538.69,1.058,1.042,1.581.536.758,1.089,1.5,1.668,2.221.372.432.742.865,1.143,1.272.481.489.962.973,1.365,1.367.36.333.722.661,1.094.98.345.3.717.57,1.079.846.718.529,1.448,1.036,2.192,1.527s1.5.918,2.245,1.339l.03.018.015.008c.562.3,1.124.6,1.705.858.649.288,1.307.539,1.867.743a19.506,19.506,0,0,0,3.119.787c.526.075,1.054.125,1.582.2.267.038.53.08.794.134a3.651,3.651,0,0,1,.438.133.808.808,0,0,1,.109.052.525.525,0,0,1,.306.1,1.548,1.548,0,0,1,.493.6,2.393,2.393,0,0,1,.212.591l-.194,0",
    transform: "translate(-8.985 -10.863)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M85.558,114.429c-.652.081-1.3.146-1.96.183-.638.039-1.278.047-1.917.053-.7-.006-1.409-.026-2.113-.031-.744-.006-1.488.011-2.232.016H77.3c-.654-.011-1.3-.041-1.957-.081q-.9-.051-1.789-.111a2.663,2.663,0,0,1-.331-.928c-.075-1.28.579-.819,1.369-.554,3.225.809,7.208,2.149,10.306.372a31.784,31.784,0,0,0,6.316-5.5c4.175-5.251,6.051-12.141,6.08-18.763.148-4.8-1.066-9.595-2.29-14.166a49.512,49.512,0,0,0-4.629-11.7c-1.707-3.006-3.906-6.081-7.177-7.472a23.86,23.86,0,0,0-4.945-.789c-.327-.021-.655-.044-.982-.063-.736-.115-1.089-1.13-1-1.79.033-.144.134-.36.319-.351a25.571,25.571,0,0,1,3.229.38c5.9.84,8.863,3.852,11.635,8.9A52.082,52.082,0,0,1,96.533,75.92c2.138,8.2,3.219,16.945.945,25.23-1.178,4.628-4.419,8.392-8.213,11.155-.995.68-2,1.386-3.041,2.024l-.666.1",
    transform: "translate(-14.953 -10.773)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M78.278,130.532h0",
    transform: "translate(-15.985 -26.656)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M77.958,55.027a84.689,84.689,0,0,0-9.048.815c-.255.041-.728-.037-.573-.405.346-.667,1.239-.627,1.876-.772.283-.574.972-.826,1.511-1.1a9.723,9.723,0,0,1,4.025-.734c.514.06,1.9-.214,1.771.627a6.965,6.965,0,0,1,1.318-.06c.209.027.489.075.575.3.167.723-.9,1.182-1.454,1.329",
    transform: "translate(-13.949 -10.788)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M82.257,129.445l-.881.105c-.571-.008-1.142-.022-1.713-.026-.744,0-1.489.01-2.233.014-.664-.01-1.327-.041-1.989-.08q-.793-.047-1.584-.1l-.01,0c-.807-.982,1.568-1.956,2.336-1.63,3.12-.138,6.327.407,9.384-.419A26.276,26.276,0,0,0,89.65,125.8c.246-.11.762-.241.972.013.37.756-1.926,1.3-2.42,1.675A19.263,19.263,0,0,1,84.271,129c-.664.178-1.338.326-2.015.445",
    transform: "translate(-15.047 -25.663)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M82.219,128.684a25.426,25.426,0,0,1-7.149-.069,18.652,18.652,0,0,1-3.442-.495c-1.031-.46-.59-1.481.2-1.927,1.339-.836,2.952-.481,4.427-.347,1.356.147,2.7.374,4.056.525,1.614.128,3.256.528,4.859.124,2.4-.787,4.148-2.815,5.635-4.757.661-.692,1.005-1.979,2.087-2.079.444,0,.341.52.135.758-2.419,3.891-6.107,7.567-10.812,8.267",
    transform: "translate(-14.504 -24.436)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M42.988,53.478A2.2,2.2,0,0,1,40.743,52.3c-1.45-1.99-1.441-4.538-1.531-6.9a5.329,5.329,0,0,1,2.1-4.969c9.489-4.106,18.477-10.3,29.009-11.326,9.4-1.122,10.5-2.518,10.369,8.1-.088,1.777.552,4.078-1.2,5.239a1.071,1.071,0,0,1-1.2.15c-2.236-.241-4.466.4-6.651.81a103.618,103.618,0,0,0-16.575,5.178c-3.1,1.171-6.139,2.62-9.423,3.19a4.833,4.833,0,0,1-2.651,1.7m2.6-3.6c4.456-3.238,10.116-4.259,15.341-5.681a164.1,164.1,0,0,1,17.341-3.657c-.538-2.636-1.444-5.185-1.928-7.828-.276-2.3-5.16-.839-6.654-.518-9.377,2.862-18.9,6.076-27.614,10.534-.224,1.763.59,3.425.923,5.122.225.8.173,1.666.477,2.437.685-.065,1.4-.558,2.114-.408",
    transform: "translate(-8.002 -5.789)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M.607,47.648c-1.424-.346.007-2.484.74-2.966,1.592-1.7,3.891-2.247,6.111-2.57a58.992,58.992,0,0,0,5.845-1.29c.949-.129,3.283-1.565,3.935-.777.378.763-.188,1.652-.643,2.258-1.318,1.7-3.779,1.426-5.639,2.144-1.814.54-3.588,1.237-5.355,1.917-1.585.459-3.311,1.928-4.994,1.284",
    transform: "translate(0 -8.13)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M7.54,59.175a5.049,5.049,0,0,1-2.3-.052c-.378-.133-.388-.583-.318-.909a4.932,4.932,0,0,1,2.468-2.7c2.969-1.848,6.445-2.549,9.793-3.394a33.155,33.155,0,0,1,3.388-.738c1.075-.227,1.253.929.924,1.7-.935,2.9-4.223,3.331-6.767,4.051a70.147,70.147,0,0,1-7.184,2.04",
    transform: "translate(-0.997 -10.487)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M14.3,70.569a23.141,23.141,0,0,1-7.168.817c-1.088-1.305,3.273-3.287,4.2-3.839a36.981,36.981,0,0,1,6.928-2.985c1.288-.21,6.925-2.414,6.4.242-1.049,3.634-7.144,4.757-10.357,5.765",
    transform: "translate(-1.422 -12.969)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M15.892,83.291c-1.089.133-4.34.937-3.93-1.012a3.625,3.625,0,0,1,1.216-1.919,16.642,16.642,0,0,1,7.811-2.952c1.827-.26,3.663-.449,5.469-.852,1.069-.119,3.085-1.05,2.448.949-.762,2.31-3.489,2.535-5.447,3.339-2.516.83-4.98,1.847-7.566,2.447",
    transform: "translate(-2.436 -15.568)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M18.579,95.029a10.811,10.811,0,0,1-2.073.208c-.385,0-.788.014-1.179-.011-.723.5-1.533.187-1.3-.752A3.059,3.059,0,0,1,16.239,92.2c4.241-2.639,9.375-3.233,14.226-3.932.8-.189.984.744.714,1.312-.7,2.212-3.233,2.5-5.085,3.322-2.479.783-4.973,1.57-7.514,2.127",
    transform: "translate(-2.857 -18.02)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M21.551,107.326c-.8-.008-2.17.313-2.636-.484-.158-1.212,1.193-2.044,2.148-2.493,3.078-1.606,6.564-1.51,9.861-2.286.962-.139,4.034-1.914,3.409.269-.516,1.685-2.362,2.063-3.864,2.427-2.952.92-5.793,2.321-8.917,2.567",
    transform: "translate(-3.86 -20.677)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M32.765,118.074c-1.23.279-12.032,2.377-10.827-.153,1.6-2.6,11.273-4.274,14.4-4.386.735-.015,1.425.3,2.161.246.543-.028.478.684.37,1.008a3.036,3.036,0,0,1-2.2,1.882,15.373,15.373,0,0,1-3.9,1.4",
    transform: "translate(-4.461 -23.185)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M37.624,129.574a64.469,64.469,0,0,1-11.218,2.206c-.5,0-1.255.212-1.62-.208-.758-2.613,6.976-4.916,8.941-5.561a34.343,34.343,0,0,1,7.754-1.316c.855.072.8,1.013.6,1.627-.615,1.94-2.573,2.926-4.455,3.253",
    transform: "translate(-5.051 -25.464)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M35.368,142.749c-2.8.411-5.769,1.48-8.546,1.075-.964-1.183,1.02-3.5,2.254-3.729,1.331-.007,2.619-.621,3.969-.7a51.123,51.123,0,0,0,7.807-1.7c1.124-.212,4.634-1.381,3.854.733-1.455,3.139-6.3,3.647-9.338,4.32",
    transform: "translate(-5.425 -28.015)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M36.221,155.606c-1.222.085-2.449.109-3.671.215-1.728.162-3.459.46-2.228-1.912.493-.842,1.443-1.954,2.53-1.719,1.626-.326,3.193-.909,4.784-1.374a34.123,34.123,0,0,1,7.891-1.876c.96-.114,2.173-.427,2.979.2,1.026,3.771-9.473,6.552-12.285,6.463",
    transform: "translate(-6.107 -30.379)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M83.876,66.7A52.082,52.082,0,0,0,78.8,52.813c-2.772-5.047-5.732-8.06-11.635-8.9q-.833-.153-1.674-.248a2.492,2.492,0,0,0-.695-.07c-.287-.026-.574-.046-.86-.061a.23.23,0,0,0-.167.062,10.755,10.755,0,0,0-2.66.355.375.375,0,0,0-.259-.059q-1.3.266-2.586.6c-.779.2-1.557.415-2.313.691a29.162,29.162,0,0,0-4.492,2.18c-.934.536-1.869,1.086-2.75,1.708A20.705,20.705,0,0,0,46.28,51.1a26.606,26.606,0,0,0-2.286,2.531c-.66.818-1.3,1.663-1.878,2.539s-1.121,1.787-1.616,2.718a28.308,28.308,0,0,0-2.451,6.057c-.141.54-.281,1.079-.369,1.631s-.17,1.105-.23,1.661a20.15,20.15,0,0,0,.288,6.57,47.942,47.942,0,0,0,1.869,6.451,56.311,56.311,0,0,0,2.574,5.916,55.051,55.051,0,0,0,3.453,5.851,30.812,30.812,0,0,0,1.937,2.589c.692.82,1.389,1.646,2.145,2.408.4.4.795.809,1.224,1.176s.852.721,1.293,1.064c.892.7,1.826,1.346,2.779,1.958.937.6,1.907,1.168,2.89,1.69.3.16.608.314.918.458a.848.848,0,0,0,.6.866,18.691,18.691,0,0,0,3.441.495,25.491,25.491,0,0,0,7.149.069,11.17,11.17,0,0,0,2.019-.5c.29-.028.582-.061.872-.1.222-.032.444-.066.666-.1,1.04-.637,2.045-1.344,3.041-2.024.306-.224.608-.451.9-.688l0,0a1.573,1.573,0,0,0,.22-.176A19.819,19.819,0,0,0,84.822,91.93c2.274-8.285,1.193-17.03-.945-25.23M74.984,32.975c.134-10.621-.969-9.225-10.369-8.1C54.083,25.9,45.1,32.093,35.606,36.2a5.33,5.33,0,0,0-2.1,4.969c.09,2.362.082,4.909,1.531,6.9a2.2,2.2,0,0,0,2.245,1.176,4.823,4.823,0,0,0,2.651-1.7c3.284-.57,6.324-2.019,9.423-3.19A103.7,103.7,0,0,1,65.93,39.174c2.184-.406,4.414-1.05,6.651-.81a1.071,1.071,0,0,0,1.2-.15c1.753-1.161,1.113-3.463,1.2-5.239M79.307,15.01c1.358,4.814,1.927,9.712,2.918,14.751.98,5.249,2.445,10.383,3.919,15.508,1.389,5.184,2.875,10.342,4.365,15.5a.437.437,0,0,0,.066.587.785.785,0,0,0,.129.094c2.17,7.5,4.34,15,6.226,22.579l0,0q.195.783.385,1.567.789,3.235,1.494,6.494c1.109,5.37,2.371,10.866,3.3,16.367.011.063.022.125.032.187.025.145.049.288.072.432s.048.287.071.433l.041.246c.29,1.816.542,3.632.735,5.443-1.222.524-2.42,1.107-3.672,1.561-2.461.726-5.064.845-7.508,1.68-2.436.689-4.843,1.489-7.223,2.356a20.346,20.346,0,0,1-4.624,1.413C75,123.489,69.985,124.9,65,126.376c-2.968.968-6.081,1.367-9.064,2.272-3.889,1.241-7.588,3.282-11.757,3.381-1.553.068-3.229.2-4.6-.675a4.986,4.986,0,0,1-2.112-2.8c-.269-.669-.521-1.346-.761-2.026a1.265,1.265,0,0,0,.079-.466c3.932-1.054,8.612-3.167,7.91-5.744-.806-.629-2.021-.317-2.979-.2a28.934,28.934,0,0,0-6.451,1.414c-.031-.094-.063-.187-.095-.28-.388-1.132-.77-2.269-1.135-3.41q-.275-.9-.526-1.812c2.975-.59,6.8-1.328,8.069-4.059.779-2.114-2.73-.945-3.854-.733-1.7.457-3.4.93-5.126,1.28q-.238-.981-.462-1.965l-.015-.066c-.28-1.267-.555-2.583-.825-3.926,1.194-.286,2.383-.6,3.573-.9,1.881-.327,3.84-1.313,4.455-3.253.206-.614.257-1.554-.6-1.627a34.343,34.343,0,0,0-7.754,1.316c-.146.047-.322.105-.525.17-.372-1.859-.777-3.711-1.178-5.562.646-.119,1.124-.218,1.331-.264a15.451,15.451,0,0,0,3.9-1.4,3.037,3.037,0,0,0,2.2-1.882c.11-.325.174-1.036-.369-1.009-.736.057-1.427-.26-2.161-.245a40.022,40.022,0,0,0-5.768.8c-.318-1.452-.646-2.9-1-4.347q-.249-1.019-.516-2.035c.67-.242,1.341-.478,2.019-.69,1.5-.362,3.348-.741,3.864-2.426.625-2.184-2.447-.409-3.409-.269-1.063.25-2.149.41-3.232.564-.614-2.223-1.265-4.439-1.931-6.649q.671-.21,1.337-.422c1.853-.82,4.381-1.109,5.085-3.321.271-.567.084-1.5-.714-1.313-2.278.329-4.619.633-6.9,1.138-.555-1.808-1.112-3.616-1.631-5.436.648-.231,1.295-.458,1.947-.673,1.959-.8,4.684-1.028,5.446-3.338.638-2-1.378-1.069-2.448-.949-1.8.4-3.64.592-5.469.852-.2.032-.4.066-.6.1-.286-1.073-.559-2.148-.806-3.229v0c-.008-.029-.014-.058-.021-.088-.061-.289-.142-.66-.22-1.031s-.151-.734-.225-1.1c2.859-.9,5.847-2.21,6.553-4.653.528-2.656-5.107-.452-6.4-.244q-.578.164-1.144.36-.184-.774-.381-1.541c-.337-1.307-.7-2.609-1.061-3.91,2.453-.645,5.366-1.2,6.238-3.907.328-.769.15-1.925-.924-1.7a33.017,33.017,0,0,0-3.388.738c-1.017.257-2.046.5-3.07.766-.572-2.062-1.157-4.119-1.768-6.171,0-.015-.009-.028-.013-.043,1.8-.562,4.033-.426,5.265-2.015.454-.606,1.02-1.494.642-2.258-.653-.789-2.987.648-3.935.777q-1.4.388-2.813.7c-.383-1.295-.747-2.6-1.047-3.907-.123-.592-.231-1.185-.318-1.78s-.142-1.2-.175-1.8c-.008-.244-.007-.489,0-.731.012-.152.028-.3.053-.45a2.932,2.932,0,0,1,.07-.286,3.631,3.631,0,0,1,.2-.441,4.6,4.6,0,0,1,.6-.756,6.1,6.1,0,0,1,1.152-.847,7.744,7.744,0,0,1,2.118-.717c.716-.125,1.441-.2,2.164-.284.743-.088,1.487-.189,2.231-.276,1.149-.137,2.3-.252,3.441-.419,1.215-.177,2.428-.363,3.632-.6,2.365-.468,4.724-1.006,7.054-1.624s4.628-1.34,6.917-2.1c1.142-.381,2.277-.781,3.418-1.163,1.2-.4,2.408-.759,3.626-1.091,1.173-.32,2.352-.609,3.536-.879q.851-.193,1.7-.386c.564-.126,1.136-.241,1.688-.416,1.179-.376,2.33-.82,3.519-1.168,1.1-.32,2.228-.565,3.357-.778,1.017-.185,2.024-.382,3.023-.635.98-.25,1.956-.532,2.918-.844.507-.165,1.011-.336,1.5-.542s1-.445,1.507-.657a25.035,25.035,0,0,1,3-.987c.938-.262,1.878-.522,2.821-.769A17.019,17.019,0,0,1,78.56,12.3c0,.014.008.028.013.041.071.236.138.472.2.709.014.045.025.088.037.132.17.609.33,1.221.493,1.826",
    transform: "translate(-2.295 -1.554)",
    fill: "#195c92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M138.331,98.785a31.482,31.482,0,0,1,1.7,8.2,2.37,2.37,0,0,1-.566,1A14.551,14.551,0,0,1,137,110.113a22.918,22.918,0,0,1-6.4,2.265c-1.1.17-2.2.375-3.288.64-1.826.2-3.7.087-5.45.738-.029.009-.057.019-.085.029a35.853,35.853,0,0,0-.68-4.858,39,39,0,0,0,3.668-1.4c1.855-.738,3.9-1.409,5.249-2.952,2.388-2.206,1.385-4.852.777-7.577-1.362-5.153-1.6-11.223-5.384-15.306a4.452,4.452,0,0,0-1.927-.515q.21-.152.413-.317a4.434,4.434,0,0,0,.781-.754,4.494,4.494,0,0,0,.41-.646,1.706,1.706,0,0,0,.244-.852,3.289,3.289,0,0,0-.1-.722,13.505,13.505,0,0,0-.508-1.382,17.381,17.381,0,0,1-.856-2.711c-.245-1.135-.415-2.283-.633-3.423s-.457-2.253-.771-3.357a23.482,23.482,0,0,0-1.352-3.544c-.232-.5-.481-.988-.731-1.475-.294-.578-.589-1.16-.935-1.709a6.021,6.021,0,0,0-1.137-1.4,3.518,3.518,0,0,0-2-.9c-.1-.007-.2-.013-.3-.014.162-.094.323-.189.482-.285.318-.195.634-.4.942-.61a5.946,5.946,0,0,0,.793-.615,2.878,2.878,0,0,0,1.017-1.707,4.152,4.152,0,0,0-.1-1.348,12.544,12.544,0,0,0-.444-1.56c-.208-.551-.435-1.093-.622-1.651-.169-.5-.318-1.014-.448-1.526-.275-1.077-.529-2.163-.727-3.257-.123-.676-.264-1.344-.419-2.013A17.93,17.93,0,0,0,116,41.583c-.2-.593-.431-1.177-.66-1.76a18.3,18.3,0,0,0-.751-1.713,7.244,7.244,0,0,0-1.077-1.575,10.143,10.143,0,0,0-1.274-1.163,5.952,5.952,0,0,0-1.613-1c-.123-.044-.247-.081-.371-.113a3.218,3.218,0,0,0,1.1-1.019,1.172,1.172,0,0,0,.1-.923c-.029-.125-.057-.251-.084-.377-.071-.339-.116-.683-.2-1.02-.111-.468-.238-.934-.384-1.393-.185-.581-.432-1.138-.614-1.72a18.405,18.405,0,0,1-.75-3.575c-.032-.314-.06-.757-.144-1.19-.073-.376-.154-.751-.236-1.124-.179-.8-.338-1.613-.448-2.43a23.306,23.306,0,0,0-.756-4.427,8.23,8.23,0,0,0-1.926-3.425,5.412,5.412,0,0,0-3.488-1.427,16.64,16.64,0,0,0-3.659.267,14.737,14.737,0,0,0-1.71.391c-.142.042-.286.087-.427.138q-.591-1.875-1.269-3.719c-.1-.225-.2-.511-.314-.823.842-.205,1.688-.393,2.539-.556a32.066,32.066,0,0,0,3.471-.813c.552-.171,1.1-.357,1.662-.5.58-.144,1.163-.261,1.75-.369.444-.081.95-.177,1.461-.247s1.011-.1,1.516-.139a15.808,15.808,0,0,1,2.724-.018,4.738,4.738,0,0,1,.831.2c.076.033.15.069.222.107s.149.1.221.158c.045.041.088.084.131.125q.124.144.243.294c.083.12.165.241.244.364.136.228.263.458.384.692q.393.814.736,1.649c.323.84.629,1.686.906,2.542l.127.409c.531,1.739.953,3.5,1.357,5.274q.223,1.011.429,2.025c.49,2.415.937,4.838,1.451,7.249.527,2.478,1.166,4.928,1.831,7.371.651,2.393,1.346,4.771,2.049,7.149.709,2.4,1.423,4.793,2.166,7.181.042.139.122.395.2.649.025.084.12.386.215.69.01.032.089.283.167.533.068.223.145.463.22.7l.01.03.047.148c.046.15.111.353.173.555q.138.445.28.89c.02.074.044.148.071.222s.049.158.076.238l.01.032c.013.041.026.083.039.123.27.868.567,1.8.859,2.727.029.093.126.4.221.705.026.084.087.281.148.477a.1.1,0,0,0,0,.014c.006.023.014.047.021.069.688,2.244,1.368,4.491,2.013,6.746.622,2.175,1.215,4.359,1.841,6.533.706,2.453,1.43,4.9,2.075,7.372.636,2.433,1.231,4.875,1.822,7.319.58,2.389,1.206,4.766,1.776,7.159q.141.592.278,1.183a2.88,2.88,0,0,0,.231,1.072c.02.056.038.114.057.171.364,1.588.723,3.179,1.1,4.765a1.883,1.883,0,0,0,.376.756.675.675,0,0,0,.486.3.107.107,0,0,0,.028,0",
    transform: "translate(-19.408 -0.77)",
    fill: "#1b3c6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M105,16.421a10.614,10.614,0,0,1,.547,1.744c.127.559.262,1.116.372,1.678.206,1.06.333,2.132.447,3.206.06.606.111,1.214.178,1.818a10,10,0,0,0,.238,1.481c.141.519.321,1.026.475,1.541s.285,1.047.417,1.572c.119.469.235.94.34,1.413.114.512.2,1.027.318,1.538a18.879,18.879,0,0,1,.416,2.049,2.616,2.616,0,0,1-.029.6c-.006.023-.014.046-.021.07-.042.073-.088.144-.136.214-.031.039-.064.078-.1.114s-.088.08-.134.12c-.072.053-.146.1-.22.151s-.146.085-.22.125c-.2.1-.41.195-.618.283-.485.188-.976.35-1.471.509a16.983,16.983,0,0,0-1.83.426c-.4.123-.8.252-1.187.411-1.625-7.671-2.974-15.556-5.241-23.136.17-.033.339-.07.508-.108.493-.112.984-.234,1.476-.351.257-.054.513-.1.772-.143.239-.031.477-.059.718-.077.141,0,.281-.007.421-.007.17.01.338.029.507.05.131.022.261.049.391.081.1.032.193.067.287.1a6.606,6.606,0,0,1,.755.429,5.812,5.812,0,0,1,.77.71A7.09,7.09,0,0,1,105,16.421",
    transform: "translate(-19.919 -2.79)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M121.921,79.534c.177.586.322,1.18.473,1.772a31.165,31.165,0,0,1,.541,3.388c.164,1.176.357,2.348.6,3.513a28.4,28.4,0,0,0,.712,2.954,12.345,12.345,0,0,1,.6,2.163,4.382,4.382,0,0,1,.02.52c-.006.152.006.3-.007.446,0,.016-.01.032-.016.048l-.015.025c-.016.021-.033.039-.05.058-.087.081-.177.158-.268.234-.215.161-.436.315-.661.463-.056.034-.111.067-.168.1l-.062.015c-.106.025-.213.052-.318.083a10.974,10.974,0,0,0-1.309.472c-.445.191-.871.421-1.319.606-.243.1-.483.2-.72.306a3.119,3.119,0,0,0-.629.389c-.191.04-.381.084-.568.132-1.226-4.917-2.515-9.824-3.865-14.686q-1.012-3.723-2.087-7.426c.18-.038.357-.081.535-.123,1.135-.249,2.291-.435,3.439-.6.419-.056.84-.107,1.261-.138.062,0,.122,0,.183,0a.042.042,0,0,1,.014,0l.1.021c.069.022.138.045.205.072.1.054.2.112.3.176a5.82,5.82,0,0,1,.859.79,10.881,10.881,0,0,1,1.591,2.555,16.848,16.848,0,0,1,.626,1.677",
    transform: "translate(-23.035 -15.161)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M128.125,104.071c1.849,1.655,2.309,4.325,2.877,6.634.7,2.773.836,5.641,1.436,8.433a10.8,10.8,0,0,1,.261,4.842c-1.365,2.195-4.366,2.8-6.74,3.419-.762-3.526-1.658-6.923-1.767-7.844-1.049-4.813-2.17-9.648-3.357-14.475a12.81,12.81,0,0,1,1.264-.328c1.942-.317,4.125-1.015,6.027-.681",
    transform: "translate(-24.676 -21.235)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M115.066,54.31c.326,1.045.59,2.1.832,3.166a26.7,26.7,0,0,1,.491,2.78c.043.461.08.922.166,1.377.069.371.152.739.231,1.108.108.506.253,1.01.329,1.523a1.225,1.225,0,0,1-.009.143c-.02.082-.042.162-.07.241l-.013.018q-.122.156-.254.3l-.08.07c-.033.025-.068.049-.1.072-.182.11-.368.21-.556.308s-.393.189-.6.276c-.62.236-1.249.452-1.872.681-.5.181-.992.384-1.485.585-.084.033-.168.067-.252.1-.266.106-.535.205-.8.309-.114.043-.226.082-.337.123-2.112-7.289-4.285-14.561-6.079-21.934-.024-.11-.049-.219-.072-.329.191-.025.379-.06.551-.09.436-.076.869-.173,1.3-.27.668-.151,1.322-.348,1.987-.508.314-.067.629-.127.948-.176.1-.014.207-.024.311-.033h.033c.064.012.127.027.189.042.144.042.284.092.425.146a5.82,5.82,0,0,1,.594.326,6.309,6.309,0,0,1,.785.715,10.347,10.347,0,0,1,1.425,2.341,14.056,14.056,0,0,1,.542,1.459c.172.555.3,1.119.446,1.681.294,1.157.634,2.308.99,3.447",
    transform: "translate(-21.347 -9.016)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M85.944,85.025C85.636,72.458,79.4,58.1,64.422,63.911c-3.416,1.565-7.967,3.565-9.986,6.853a17.454,17.454,0,0,0-1.611,6c-.521,4.039.778,7.971,2.348,11.654,3.078,6.5,6.828,13.576,13.119,17.457a14.509,14.509,0,0,0,6.242,2.932,7.571,7.571,0,0,0,5.3-1.309c2.421-1.632,3.774-4.363,4.764-7.028,1.673-4.967,1.53-10.273,1.346-15.442M89.313,75.5c1.225,4.571,2.438,9.363,2.29,14.167-.029,6.622-1.905,13.512-6.079,18.762a29.812,29.812,0,0,1-4.5,4.193c-.412.136-.827.263-1.245.379a14.507,14.507,0,0,1-3.243.45c-.49-.059-.98-.123-1.467-.161-1.356-.152-2.7-.378-4.056-.526a9.735,9.735,0,0,0-3.614-.017l-.386-.122c-.559-.2-1.218-.455-1.866-.743-.582-.256-1.144-.555-1.705-.858l-.015-.008L63.4,111c-.746-.42-1.51-.85-2.245-1.339s-1.475-1-2.192-1.527c-.362-.276-.734-.548-1.079-.846-.372-.319-.734-.647-1.094-.98-.4-.394-.885-.878-1.365-1.367-.4-.407-.77-.84-1.143-1.272-.579-.723-1.132-1.463-1.668-2.221-.353-.523-.714-1.043-1.042-1.581s-.655-1.084-.979-1.629c-.675-1.21-1.292-2.444-1.884-3.7-.395-.887-.784-1.774-1.123-2.683-.008-.024-.016-.048-.025-.072s-.025-.068-.037-.1-.032-.084-.047-.127c0-.006-.01-.025-.017-.045l-.017-.047c-.041-.111-.085-.232-.127-.351-.018-.049-.036-.1-.053-.145l0-.014c-.007-.02-.015-.039-.022-.06-.307-.906-.6-1.822-.871-2.752-.284-1.1-.523-2.205-.735-3.321-.082-.493-.153-.984-.214-1.482-.037-.485-.08-.971-.077-1.457v-.007c0-.019,0-.037,0-.057,0-.171.006-.353.009-.539l0-.177c.042-.783.107-1.555.2-2.333.07-.466.125-.941.228-1.4.109-.481.228-.957.357-1.435.285-.924.593-1.836.952-2.735.346-.867.756-1.7,1.179-2.536.622-1.16,1.292-2.283,2.024-3.377.365-.547.785-1.062,1.191-1.578s.8-1.007,1.222-1.5l.372-.423c.6-.638,1.3-1.3,2.026-1.931.332-.29.668-.571,1.022-.835s.711-.495,1.077-.727a32.439,32.439,0,0,1,4.976-2.437c.872-.34,1.75-.649,2.647-.919q1.306-.39,2.632-.711c.3-.069.693-.158,1.09-.24a.4.4,0,0,0,.216-.112c1.486-.1,2.975-.167,4.454-.281a20.775,20.775,0,0,1,4.292.729c3.271,1.391,5.47,4.467,7.177,7.472a49.486,49.486,0,0,1,4.629,11.7",
    transform: "translate(-9.258 -11.354)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M70.416,32.983c1.493-.321,6.377-1.778,6.654.519.485,2.642,1.391,5.192,1.929,7.828a163.576,163.576,0,0,0-17.341,3.657c-5.225,1.421-10.886,2.442-15.342,5.681-.718-.15-1.428.342-2.113.407-.3-.771-.252-1.639-.477-2.437-.332-1.7-1.148-3.36-.924-5.122,8.714-4.459,18.239-7.672,27.615-10.535",
    transform: "translate(-8.733 -6.582)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M82.49,71.856a25.145,25.145,0,0,1,3.557,9.288,54.481,54.481,0,0,1,.715,7.641c.278,4.826,0,9.878-2.3,14.231-1.268,2.262-2.694,4.818-5.316,5.675-2.93.492-5.714-.947-8.26-2.252-6.5-3.917-10.281-11.03-13.026-17.875-1.734-4.373-2.16-9.767.589-13.816,4.09-5.676,11.7-7.425,18.334-6.421a7.255,7.255,0,0,1,5.707,3.529",
    transform: "translate(-11.532 -13.899)",
    fill: "#195c92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M45.619,50.5c-1.05-.1-1.5-1.184-1.869-2.023a4.845,4.845,0,0,1,1.28-5.752c5.206-4.628,18.559-8.711,25.554-9.957,1.193-.23,2.381-.485,3.572-.72A1.58,1.58,0,0,1,75.67,34.51c-.361.624-1.456.71-1.987.836-3.949.9-7.858,1.992-11.734,3.176a42.408,42.408,0,0,0-12.3,5.473c-1.978,1.3-2.712,2.28-2.434,4.7a1.563,1.563,0,0,1-1.6,1.8",
    transform: "translate(-8.838 -6.539)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M59.3,107.713a.818.818,0,0,1-.3-.374c-3.21-2.369-5.066-6.046-7.043-9.416C49,92.239,46.683,83,47.3,76.605A20.411,20.411,0,0,1,55.245,63.04a35.051,35.051,0,0,1,10.679-6.33,17.98,17.98,0,0,1,8.821-.832,17.161,17.161,0,0,1,2.882.689c.819.131,1.675.65,1.458,1.607a1.241,1.241,0,0,1-1.464.941c-.711-.166-1.432-.283-2.145-.433a17.493,17.493,0,0,0-3.963-.533A18.179,18.179,0,0,0,64.3,59.838C58.658,62.183,53.164,66,50.942,71.92c-2.846,5.758-2.166,12.448-.122,18.346a35.088,35.088,0,0,0,5.6,11.327c1.152,1.673,2.872,2.917,3.833,4.719a.846.846,0,0,1-.948,1.4",
    transform: "translate(-9.639 -11.37)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M102.448,17.577c-.822-.375-1.662-.719-2.511-1.027a2.688,2.688,0,0,1-1.178-.5.955.955,0,0,1,.682-1.6c1.416-.178,2.691.61,3.906,1.222a1.056,1.056,0,0,1-.9,1.907",
    transform: "translate(-20.112 -2.945)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M110.6,48.243a9.824,9.824,0,0,0-3.345-1.526.838.838,0,0,1-.956-.443.8.8,0,0,1,.441-1.062,3.016,3.016,0,0,1,2.738.154,16.173,16.173,0,0,1,2.207,1.4.917.917,0,0,1-1.085,1.478",
    transform: "translate(-21.694 -9.177)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M118.046,78.494c-.918-.71-2.041-1.1-2.987-1.738-.613-.633.222-1.389.908-1.392a3.6,3.6,0,0,1,2.508.914c.42.373,1.058.644,1.158,1.254a1.012,1.012,0,0,1-1.587.962",
    transform: "translate(-23.453 -15.388)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M110.692,47.4a3.356,3.356,0,0,1-1.717-1.194c-.629-1.2.715-1.7,1.675-1.271a2.174,2.174,0,0,1,1.436,1.353,1.038,1.038,0,0,1-1.4,1.113",
    transform: "translate(-22.221 -9.146)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M128.453,107.294c-.656-.462-2.144-1.381-1.117-2.206.92-.473,1.873.531,2.219,1.316a.736.736,0,0,1-1.1.89",
    transform: "translate(-25.932 -21.435)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M65.865,111.7l0,0,0,0",
    transform: "translate(-13.45 -22.81)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M65.827,111.66l.021.021-.021-.021",
    transform: "translate(-13.443 -22.802)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M65.854,111.688l0,0,0,0",
    transform: "translate(-13.448 -22.808)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M22.766,56.316a2.37,2.37,0,0,1-1.38-4.207,3.4,3.4,0,0,1,2.909-.54,1.866,1.866,0,0,1,.622,3.038,2.2,2.2,0,0,1-2.151,1.709",
    transform: "translate(-4.187 -10.502)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M18.132,45c-2.353-1.168-1.291-5.182,1.47-4.471,2.32.045,2.859,3.91.329,4.107a1.7,1.7,0,0,1-1.8.364",
    transform: "translate(-3.438 -8.26)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M114.288,43.974a2.435,2.435,0,0,1-.473-.992.952.952,0,0,1,.17-1.453.933.933,0,0,1,1.282.316c2.32.84.679,3.659-.979,2.13",
    transform: "translate(-23.189 -8.453)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M123.447,74.376a1.743,1.743,0,0,1-1.14-3.026c-.337-1.276,1.428-1.654,1.543-.372a1.739,1.739,0,0,1-.4,3.4",
    transform: "translate(-24.865 -14.332)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M47.061,164.577h0",
    transform: "translate(-9.609 -33.609)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M46.985,164.577h0",
    transform: "translate(-9.595 -33.609)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M139.788,82.238v0",
    transform: "translate(-28.546 -16.794)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M139.772,82.194l.008.023-.008-.023",
    transform: "translate(-28.543 -16.785)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M150.892,129.647l0,.022a.125.125,0,0,1,0-.022",
    transform: "translate(-30.814 -26.475)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M118.432,9.995q.013.031.024.062l-.024-.062",
    transform: "translate(-24.185 -2.041)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M118.412,9.94l-.006-.015c.006.014.011.029.016.043l-.01-.028",
    transform: "translate(-24.18 -2.027)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M86.674,130.591a14.937,14.937,0,0,1-5.971.145c-1.87-.256-4.019-.337-5.529-1.591a1.39,1.39,0,0,1-.029-1.812,2.673,2.673,0,0,1,.535-.431q.44.164.887.3c.65.205,1.3.4,1.953.6a7.64,7.64,0,0,0,4.055.544c.054-.012.108-.026.161-.039l.267.031a1.122,1.122,0,0,0,.411-.031,1.177,1.177,0,0,0,.586-.373c.342-.111.684-.225,1.028-.333a13.853,13.853,0,0,0,1.994-.8,9.02,9.02,0,0,0,1.884-1.179c.341-.3.676-.6,1-.918a2.432,2.432,0,0,1,.415,4.463,12.863,12.863,0,0,1-3.406,1.35l-.24.063",
    transform: "translate(-15.28 -25.468)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(43.581 51.399)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M56.941,87.733c.12.625.228,1.251.343,1.876.478,1.2.959,2.4,1.463,3.584.244.54.49,1.081.729,1.627.225.5.465.993.67,1.5.129.316.259.633.387.949.116.281.23.563.321.851l.227.264q1.232,1.442,2.427,2.912a.712.712,0,0,1,.083.771l0,0,.006.006.006.006.051.05q.839.8,1.677,1.6a.221.221,0,0,1,.108.053c.6.561,1.206,1.125,1.81,1.685l.087.082.08.069c.1.092.206.185.31.276l1.285,1.066-.095-.079q1.086.887,2.176,1.767c.192.157.384.313.574.471.108.06.216.119.326.179h0c.149.074.3.149.444.219a1.344,1.344,0,0,1,1.006.3c.016.015.033.029.048.044a1.762,1.762,0,0,0-.367-2.091q-.6-.554-1.155-1.14c-2.661-3.6-6.144-6.439-8.5-10.314-2.147-7.193-4.437-13.914.115-20.848a17.128,17.128,0,0,1,8.653-6.289,42.933,42.933,0,0,1,5.592.313,11.91,11.91,0,0,0,3.536.082,2.153,2.153,0,0,0,.653-.268l-.21-.169q-.7-.562-1.4-1.114c-.422-.331-.839-.672-1.276-.984q-.789-.566-1.58-1.128l-.495-.33a1.611,1.611,0,0,1-.274.119A1.731,1.731,0,0,1,75.71,65.7a7.747,7.747,0,0,1-1.167-.5q-.352-.17-.7-.347c-.16-.08-.318-.165-.474-.252a27.763,27.763,0,0,0-3.536.15c-.365.141-.733.275-1.1.417-.216.095-.426.193-.635.3-.883.5-1.732,1.058-2.628,1.54-.527.284-1.064.549-1.6.817a2.448,2.448,0,0,1-.259.28c-.4.368-.838.689-1.257,1.031a11.193,11.193,0,0,1-2.208,1.588,3.649,3.649,0,0,1-.612.226,2.522,2.522,0,0,1-1.41,0c-.122.146-.242.294-.359.444a18.859,18.859,0,0,0-3,6.976,1.286,1.286,0,0,1,.777.972q.412,2.886.9,5.76c.149.883.331,1.763.5,2.643",
    transform: "translate(-54.765 -64.589)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(56.903 52.221)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M71.506,65.674l.011,0,.079-.047c-.029.018-.06.035-.09.052",
    transform: "translate(-71.506 -65.622)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(36.984 117.407)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M50.693,153.8a3.086,3.086,0,0,0,.432-5.858,3.149,3.149,0,0,0-4.509,3.686,3.307,3.307,0,0,0,4.077,2.172",
    transform: "translate(-46.475 -147.536)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(34.471 108.272)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M48.3,136.858c-3.4-2.969-7.134,3.1-3.493,5.227,3.333,1.674,5.988-2.74,3.493-5.227",
    transform: "translate(-43.316 -136.056)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(31.558 98.307)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M41.027,124.961c-2.71,1.813-1.087,6.269,2.122,6.089,3.281-.028,4.542-4.3,2.29-6.482-1.171-1.419-3.641-1.458-4.413.393",
    transform: "translate(-39.657 -123.535)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(29.655 89.099)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M37.934,116.776c3.265,3.438,7.469-1.962,3.525-4.451-2.706-1.533-5.51,2.157-3.525,4.451",
    transform: "translate(-37.264 -111.963)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(26.409 79.096)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M34.911,99.645a2.934,2.934,0,0,0,.424,5.5,3.234,3.234,0,0,0,3.852-2.464,3.134,3.134,0,0,0-4.276-3.038",
    transform: "translate(-33.186 -99.393)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(23.961 69.952)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M33.756,88.479a2.17,2.17,0,0,0-3.611,1.432,2.55,2.55,0,0,0,2.934,2.863c2.139-.286,3.117-3.669.677-4.3",
    transform: "translate(-30.11 -87.903)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(21.653 59.455)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M28.055,80.128c2.648,3.049,6.9-1.42,4-4.063-2.315-3.328-6.69.047-4,4.063",
    transform: "translate(-27.209 -74.712)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(18.671 49.466)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M28.709,63.85a2.732,2.732,0,1,0-4.7,2.717c1.51,3.139,6.038.017,4.7-2.717",
    transform: "translate(-23.462 -62.16)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(12.531 30.16)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M18.417,44.795c4.012,1.128,5.877-4.682,2.307-6.469-4.589-2.272-7.289,5.23-2.307,6.469",
    transform: "translate(-15.747 -37.9)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(15.329 39.481)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M22.415,49.628c-3.825-.389-4.37,6.224-.524,6.536,4.428.3,4.591-5.859.524-6.536",
    transform: "translate(-19.262 -49.612)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(85.789 11.178)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M124.871,114.372a5.285,5.285,0,0,0,.742-.142,2.861,2.861,0,0,0,1.506-.926,2.105,2.105,0,0,0,.828.01c4.1-.657,6.136-4.8,6.807-8.514a29.707,29.707,0,0,0-2.484-16.192c.755-2.809-4.209-10.467-4.647-12.752C125.965,71,126.137,65.73,123.473,61.2a6.091,6.091,0,0,0-.977-1.409,1.112,1.112,0,0,0,.36-.874,42.646,42.646,0,0,0-.688-5.521c-1.037-5.185-1.942-10.468-4.321-15.242-.821-1.72-1.6-3.641-3.091-4.877a5.07,5.07,0,0,1-.053-.721A42.044,42.044,0,0,0,112.5,20.376a9.848,9.848,0,0,1-.524-1.86,12.18,12.18,0,0,0-1.53-3.492c-.548-1.035-2.154-1.494-2.59-.132a2.952,2.952,0,0,0,.4,1.853,21.413,21.413,0,0,0,2.389,4.808c.515,2.547.892,5.124,1.537,7.644a20.024,20.024,0,0,1,.735,3.055,7.245,7.245,0,0,0-.032,1.295,1.5,1.5,0,0,0-.563,1.183,14.715,14.715,0,0,0,.943,3.412c2.155,4.763,4.436,9.5,5.577,14.635.472,1.892.988,3.773,1.424,5.673a3.029,3.029,0,0,0-.461-.108,1.059,1.059,0,0,0-1.138,1.433c.007,1.771,1.092,3.166,1.755,4.722.555,1.669,1.076,3.349,1.645,5.016a33.055,33.055,0,0,1,2.157,8.731c.286,1.463.179,4.2,1.66,4.865,1.592,5.286,3.166,10.583,4.551,15.925a8.346,8.346,0,0,1-4.3,10.195,2.008,2.008,0,0,0-.169.182,3.983,3.983,0,0,0-2-.561,3.025,3.025,0,0,0-2.034.893c.017.3.04.6.067.892.085.883.193,1.761.294,2.643.019.17.037.339.054.509a3.121,3.121,0,0,0,2.52.586",
    transform: "translate(-107.804 -14.046)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(111.292 65.58)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M139.851,82.408c0,.013.009.025.014.037l-.007-.019-.006-.018",
    transform: "translate(-139.851 -82.408)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(35.806 0.227)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M126.074,79.2a156.7,156.7,0,0,1-4.893-16.059c-1.314-5.5-2.1-11.113-3.362-16.626a204.211,204.211,0,0,0-6.677-23.374c-1.668-4.448-3.032-9-5.025-13.325-1.34-2.839-2.225-5.913-3.8-8.632a2.091,2.091,0,0,0-3.79,1.008,2.814,2.814,0,0,1,.549.02,2.965,2.965,0,0,1,1.407.661,5.412,5.412,0,0,1,1.045,1.112,9.17,9.17,0,0,1,.941,1.627c.348.733.624,1.506.914,2.266a.6.6,0,0,0,.024.063l0,.013.016.044.008.018v0c.007.02.015.038.021.059.214.555.415,1.111.618,1.668.239.656.438,1.324.648,1.993-.006-.016-.01-.031-.015-.047q.29.929.541,1.87a1.372,1.372,0,0,1,.709.5,3.112,3.112,0,0,1,.311.477c.088.181.164.364.238.552.116.3.223.6.329.9a9.055,9.055,0,0,1,.335,1.219c.17.813.326,1.625.474,2.441.139.768.259,1.535.36,2.308a8.549,8.549,0,0,1-.054,2.512,1.085,1.085,0,0,1-.353.618c1.526,4.65,2.707,9.4,3.839,14.179a1.809,1.809,0,0,1,.723.822,17.1,17.1,0,0,1,.666,1.91c.179.594.364,1.184.554,1.775.366,1.148.778,2.281,1.14,3.43q.519,1.646.992,3.307a35.192,35.192,0,0,0,1.1,3.365c.267.624.544,1.243.782,1.877.23.617.4,1.253.624,1.871.235.65.476,1.3.676,1.957.189.629.348,1.269.54,1.9.229.72.462,1.437.664,2.165.183.662.364,1.32.576,1.973-.029-.079-.058-.158-.088-.236.018.049.037.1.054.146l-.006-.013a.275.275,0,0,1,.01.027v0c.01.025.019.052.028.077l.017.044c0,.01.007.021.011.03l.031.082c-.014-.034-.025-.068-.037-.1.048.131.1.263.146.395.232.608.491,1.207.715,1.819.213.587.365,1.2.52,1.8l.029.113.006.02,0,0,0,.01c.007.029.015.057.022.085,0,.013.006.026.01.039.021.08.042.159.064.24.151.564.3,1.129.444,1.694a11.385,11.385,0,0,1,.24,2.064c0-.076-.009-.152-.014-.228l.024.38c0,.049.006.1.01.151l0-.04c.018.238.033.474.051.712.033.353.067.7.1,1.055.042.375.081.751.12,1.127,0-.014,0-.028,0-.044.018.174.037.348.056.522v-.016c.006.055.012.111.018.166l0-.029c0,.033.008.068.011.1.01.088.019.177.03.267.166,1.354.4,2.7.615,4.049.1.61.212,1.218.3,1.83.06.4.12.8.181,1.2.018.124.037.251.053.378.9,3.006,1.74,6.04,2.445,9.132q.093.409.184.82a3.081,3.081,0,0,1,.368.735c.134.34.257.683.373,1.03l.027,0a.8.8,0,0,1,.664.608c.017.055.031.11.043.166a1.044,1.044,0,0,1,.387.76c.031.33.06.661.091.992.165,1.575.42,3.135.705,4.69.132.615.264,1.233.354,1.853.051.179.1.358.15.536a1.364,1.364,0,0,1-.334,1.288.945.945,0,0,1-.583.385l-.025.006a1.247,1.247,0,0,1-.286.043c0,.117.009.235.014.353a6.142,6.142,0,0,0-.4.526,12.807,12.807,0,0,1-3.174,2.323,73.887,73.887,0,0,1-11.188,3.735c-6.506,1.694-13,3.442-19.5,5.175-7.063,2.023-14.131,4.076-21.329,5.574-5.416,1.1-10.835,2.256-16.319,2.907a1.493,1.493,0,0,1-.715.606,12.461,12.461,0,0,1-1.478.481c-.116.031-.232.062-.347.09a25.3,25.3,0,0,1-2.519.553,15.222,15.222,0,0,1-2.135.154c-.61.022-1.219.054-1.83.034-.412-.014-.825-.049-1.237-.055h-.062c-.137,0-.272-.006-.408-.014l.2,0c.07-.009.141-.019.21-.029a1.7,1.7,0,0,1-1.237-.238c-.044-.029-.086-.061-.127-.095a2.658,2.658,0,0,0,.673,2.988c2.166,2.029,6.008,1.856,8.814,1.7,3.284-.445,6.506-1.263,9.754-1.921a80.587,80.587,0,0,0,10.051-2.826c7.323-2.339,14.835-3.987,22.331-5.653,6.245-1.345,12.624-2.994,18.855-4.543q1.862-.474,3.717-.969c2.041-.547,4.075-1.12,6.1-1.738a10.163,10.163,0,0,0,6.763-4.733,6.488,6.488,0,0,0,.961-1.77c1.568-2.461.813-6.1.429-8.833A162.969,162.969,0,0,0,126.074,79.2",
    transform: "translate(-44.995 -0.285)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(119.624 99.665)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M150.334,125.365l-.007-.078c0-.015,0-.031-.006-.047.006.042.01.083.014.125",
    transform: "translate(-150.321 -125.24)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(111.305 65.616)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M139.874,82.468v0l0-.011,0,.013",
    transform: "translate(-139.868 -82.455)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(111.269 65.516)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M139.822,82.328l.024.064-.01-.026-.014-.037",
    transform: "translate(-139.822 -82.328)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(33.518 22.901)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M42.948,53.159c1.923,1.466,4.621,1.292,6.878.89,3.946-.761,7.238-3.248,11.083-4.358,3.928-1.549,8.1-2.268,12.09-3.6,2.876-1.021,6.222-1.063,8.739-2.9,2.393-1.946,2.239-5.387,1.159-8-.793-2.037-.171-5.076-2.356-6.283a1.374,1.374,0,0,0-1.93,1.185c.092,1.962,1.543,3.587,2,5.48.112.862.4,3.834-.465,4.2-3.752,1.164-7.485,2.392-11.34,3.182-5.74,1.767-11.33,4-17.009,5.959-2.6,1.288-5.439,1.545-8.22,2.167a1.089,1.089,0,1,0-.634,2.08",
    transform: "translate(-42.119 -28.778)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(55.198 43.398)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M84.691,117.369c.261-.054.519-.115.776-.184,5.266-1.41,9.627-5.957,12.172-10.618,2.154-4.383,2.792-9.352,3.025-14.18a33.472,33.472,0,0,0-.227-7.956,29.056,29.056,0,0,0-.789-3.8,36.875,36.875,0,0,0-1.475-3.482c-1.024-2.375-1.746-4.863-2.557-7.315a19.275,19.275,0,0,0-1.75-4.953,16.985,16.985,0,0,0-4.287-5.957,16.814,16.814,0,0,0-4.039-3.077c-.966-.495-2.064-.651-3.012-1.19A1.169,1.169,0,0,0,81,55.1a.765.765,0,0,1,.4.189c.24.138.487.267.727.405A9.173,9.173,0,0,1,83.765,57c.053.048.1.1.154.145.276.222.544.453.815.683.6.51,1.166,1.068,1.735,1.611q.413.394.832.782c.138.129.279.255.411.391l.221.229a3.644,3.644,0,0,1,.43.586,1.758,1.758,0,0,1,.27.976c.066.088.13.176.193.266.344.485.668.972.984,1.472a21.678,21.678,0,0,1,1.514,2.835,10.672,10.672,0,0,1,.744,2.141c.271.566.531,1.138.784,1.717a20.238,20.238,0,0,1,.746,2.048c.225.722.449,1.445.676,2.167.241.765.478,1.531.683,2.305.214.809.338,1.64.47,2.465.007.049.016.1.023.146.1.509.207,1.015.326,1.518.127.543.271,1.085.364,1.635s.117,1.105.165,1.658.084,1.135.109,1.7a20.159,20.159,0,0,1,.213,2.783c-.006.075-.015.15-.029.223s-.015.162-.025.241c0-.009,0-.019,0-.028l-.007.068,0-.033c0,.029-.007.057-.01.087h0v.008c-.085.764-.195,1.526-.263,2.293,0,.084,0,.169-.006.252a1.029,1.029,0,0,1-.23.88,50.085,50.085,0,0,1-1.029,8.694c-1.1,4.421-5.348,9.828-9.823,11.1a19.062,19.062,0,0,1-2.414.651,1.179,1.179,0,0,1-.5.282,1.094,1.094,0,0,1-.408.031c-.089-.01-.178-.02-.267-.032l-.161.04a5.466,5.466,0,0,1-2.608-.115,43.838,43.838,0,0,1-6.243-1.319,6.133,6.133,0,0,0-2.865-.181c-.742.306-.246,1.286.191,1.672,3.9,3.539,9.728,4.476,14.757,3.289",
    transform: "translate(-69.363 -54.535)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M103.542,98.884v0",
    transform: "translate(-21.144 -20.193)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M103.542,98.878v0",
    transform: "translate(-21.144 -20.192)",
    fill: "#011e41"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoninBookLoadingIcon);
export default __webpack_public_path__ + "static/media/PhoninBook-Loading-Icon.2c53474a8d70302aa2790e207993a65a.svg";
export { ForwardRef as ReactComponent };